import React from "react";
import { Box, Stack, Title, Detail, constants } from "@thecb/components";

const { BLACK, CHARADE_GREY, ZEST_ORANGE } = constants.colors;
const { FONT_WEIGHT_SEMIBOLD } = constants.styleConstants;

const InactiveTitleModule = ({ title, subtitle, autoPayEnabled }) => (
  <Box padding="0">
    <Stack childGap="0">
      <Title
        variant="small"
        as="h3"
        color={CHARADE_GREY}
        weight={FONT_WEIGHT_SEMIBOLD}
      >
        {title}
      </Title>
      <Detail variant="small" as="p" color={CHARADE_GREY}>
        {subtitle}
      </Detail>
      <Detail
        variant="small"
        as="p"
        color={ZEST_ORANGE}
        weight={FONT_WEIGHT_SEMIBOLD}
      >
        Unable to load account details
      </Detail>
      <Detail variant="extraSmall" as="p" color={BLACK}>
        {`This may mean that the account has been paid off or there was an error loading it. If you have questions about this account, please contact us.${
          autoPayEnabled
            ? " You may disable autopay for this account by pressing the 'Turn off Autopay' button."
            : ""
        }`}
      </Detail>
    </Stack>
  </Box>
);

export default InactiveTitleModule;
